// To be separated into different files, add types and mocks
import { createHttpEndpoint } from '../../utils'

/**
 * Create BuyBack order
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/sourcingNewOrder}
 */
export const postOrder = createHttpEndpoint({
  method: 'POST',
  operationId: 'swapCreateOrder',
  path: '/bm/sourcing/order/new',
  transformRequestToSnakeCase: true,
})

/**
 * BuyBack available shippings
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/buybackShipping}
 */
export const getShippingModes = createHttpEndpoint({
  method: 'GET',
  operationId: 'getBuybackShipping',
  path: '/bm/sourcing/shipping_modes/:listingId',
})

/**
 * Send Shipping Label
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/sendShippingLabel}
 */
export const postShippingLabelEmail = createHttpEndpoint({
  method: 'POST',
  operationId: 'emailPrepaidLabel',
  path: '/bm/buyback/v1/customer/orders/:id/shipping',
})

/**
 * Buyback order counter offer details
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/getBuybackOrderCounterOffer}
 */
export const getCounterOffer = createHttpEndpoint({
  method: 'GET',
  operationId: 'getCounterOfferDetails',
  path: '/bm/buyback/v1/customer/orders/:id/counter-offer/pending',
})

/**
 * Respond to a counter offer
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/putBuybackOrderCounterOffer}
 */
export const putCounterOffer = createHttpEndpoint({
  method: 'PUT',
  operationId: 'respondToCounterOffer',
  path: '/bm/buyback/v1/customer/orders/:id/counter-offer/pending',
})

/**
 * Get buyback messages on a given order
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/get-bm-buyback-customer-orders-messages}
 */
export const getCustomerOrderMessages = createHttpEndpoint({
  method: 'GET',
  operationId: 'getCustomerOrderMessages',
  path: '/bm/buyback/v1/customer/orders/:id/messages',
})

/**
 * Post a buyback messages on discussion for a given order
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/post-bm-buyback-customer-orders-messages}
 */
export const postCustomerOrderMessage = createHttpEndpoint({
  method: 'POST',
  operationId: 'postCustomerOrderMessage',
  path: '/bm/buyback/v1/customer/orders/:id/messages',
})

/**
 * Get conversation message metadata
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/get-bm-buyback-conversation-order-metadata}
 */
export const getCustomerOrderMetadata = createHttpEndpoint({
  method: 'GET',
  operationId: 'getCustomerOrderMetadata',
  path: '/bm/buyback/v1/customer/orders/:id/messages/metadata',
})

/**
 * Create customer return Address
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/createCustomerReturnAddress}
 */
export const postCustomerAddress = createHttpEndpoint({
  method: 'POST',
  operationId: 'setClientSourcingAddress',
  path: '/bm/client/address/sourcing',
  transformRequestToSnakeCase: true,
})

/**
 * TODO Add API specs when available
 */
export const getOrderConfirmation = createHttpEndpoint({
  method: 'GET',
  operationId: 'getConfirmation',
  path: '/bm/sourcing/order/:id/confirmation',
})
